<template>
  <b-row class="match-height">
    <b-col
      lg="6"
    >
      <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
        <div>
          <span style="color:#ffffff;font-size:24px; margin-left:0px">5 Top จุดติดตั้งที่กำลังไฟฟ้าสูงสุด</span>
        </div>
        <b-row
          v-for="(item, index) in progress.slice(0,5)"
          :key="index"
          style="margin-top:10px"
          class="mt-2"
        >
          <b-col
            lg="10"
          >
            <label style="color: #ffffff; font-size: 18px;">{{ index+1 +'. ' }} {{ item.detail }}</label>
            <b-progress
              :value="item.Total_watt"
              :max="progress[0].Total_watt + 50"
              precision="2"
              class="progress8"
            />
          </b-col>
          <b-col
            lg="2"
            style="text-align: left;"
          >
            <br>
            <span style="color:#ffffff; ">{{ item.Total_watt }} วัตต์</span>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
    <b-col
      lg="6"
    >
      <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 420px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
        <div>
          <b-img
            style="margin-top: -5px"
            src="@/assets/images/icons/light2.svg"
          />
          <span style="font-size:20px; color: #fff; margin-left: 15px;">กำลังไฟฟ้าที่ใช้ไปของทุกสายทาง (Watt)</span>
        </div>
        <div>
          <app-echart-bar
            :option-data="optionBar"
            style="width:auto; height:350px;"
          />
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BProgress, BImg, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import * as echarts from 'echarts'
import AppEchartBar from '@/views/lighting/total/AppEchartBarlighting.vue'

export default {
  components: {
    BRow,
    BCol,
    BProgress,
    AppEchartBar,
    BImg,
    BCard,
  },
  data() {
    return {
      optionBar: {
        xAxisData: [],
        series: [
          {
            name: 'ทั้งหมด',
            type: 'bar',
            stack: 'Total',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#99FBCA',
              },
              {
                offset: 1,
                color: '#00B058',
              },
              ]),
              barBorderRadius: [4, 4, 0, 0],
            },
            data: [],
            barMaxWidth: '40%',
            barMinWidth: '10px',
          },
        ],
      },
      progress: [],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getTop5()
    this.getBarChart()
    this.interval = setInterval(() => {
      this.getTop5()
    }, 300000)
  },
  methods: {
    getBarChart() {
      axios
        .post('/getBarWattLightingTotal', { department: this.userData.department })
        .then(response => {
          this.xAxisData = []
          this.optionBar.xAxisData.splice(0)
          this.optionBar.series[0].data.splice(0)
          this.xAxisData = response.data
          this.xAxisData.forEach(value => {
            this.optionBar.xAxisData.push(value.Date_Th)
            this.optionBar.series[0].data.push(value.watt)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    getTop5() {
      axios
        .post('/getTop5LightingTotal', { department: this.userData.department })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.progress = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">

  .progress8 .progress-bar{background: linear-gradient(90deg, #00B058 46.03%, #99FBCA 100%)}

.br {
      display: block;
      margin-bottom: 0em;
    }
  </style>
